import { useState } from 'react'
import { getNotifSettings } from './NotificationBell'

function Toggle({ on, onChange, disabled }) {
  return (
    <button type="button" disabled={disabled} onClick={() => onChange(!on)}
      style={{ width: 44, height: 24, borderRadius: 99, border: 'none', cursor: disabled ? 'not-allowed' : 'pointer', position: 'relative', background: on && !disabled ? '#4F46E5' : '#CBD5E1', opacity: disabled ? 0.5 : 1, transition: 'background 0.15s' }}>
      <span style={{ position: 'absolute', top: 2, left: on ? 22 : 2, width: 20, height: 20, borderRadius: '50%', background: '#fff', transition: 'left 0.15s', boxShadow: '0 1px 2px rgba(0,0,0,0.3)' }} />
    </button>
  )
}

// Notification preferences (stored in localStorage; read live by NotificationBell).
export default function NotificationSettings({ t }) {
  const [s, setS] = useState(getNotifSettings())

  function update(key, val) {
    localStorage.setItem(key === 'enabled' ? 'eh_notif_enabled' : 'eh_notif_sound', val ? '1' : '0')
    setS((prev) => ({ ...prev, [key]: val }))
    window.dispatchEvent(new Event('eh-notif-settings'))
  }

  const Row = ({ title, desc, on, onChange, disabled }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, padding: '12px 0', borderBottom: `1px solid ${t.border}` }}>
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, color: t.text }}>{title}</div>
        <div style={{ fontSize: 12, color: t.textMuted, marginTop: 2 }}>{desc}</div>
      </div>
      <Toggle on={on} onChange={onChange} disabled={disabled} />
    </div>
  )

  return (
    <div>
      <Row title="Enable notifications" desc="Show the bell badge and alerts for new activity" on={s.enabled} onChange={(v) => update('enabled', v)} />
      <Row title="Notification sound" desc="Play a sound when a new notification arrives" on={s.sound} onChange={(v) => update('sound', v)} disabled={!s.enabled} />
    </div>
  )
}
